var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"nuttrema-show-hide-button",on:{"click":_vm.changeState}},[_vm._v("\n  "+_vm._s(_vm.state ? _vm.$t('label.hide_details') : _vm.$t('label.show_details'))+" "),_c('i',{class:[_vm.state ? _vm.iconUp : _vm.iconDown]})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6733d2b6","hasScoped":true,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/button/nuttrema-show-hide-button.vue
// module id = 3151
// module chunks = 0